import { Mixins } from 'vue-property-decorator';
export default class MerchantWidget extends Mixins() {
    redirectToMerchantSpace() {
        this.$emit('goto-link', true, 'https://sellercenter.chatgenie.ph/communities/groups/chatgenie-clients/home');
    }
}
